export default __webpack_public_path__ + "static/media/Group 1925.cddf32f1.svg";